import React from "react";
import QuestionItem from "./QuestionItem";

import "../../assets/css/question-template.css";

export default function QuestionList({ questionsData, isParentQuestion }) {
  return (
    <div className="list">
      {questionsData && questionsData.map((item) => {
          return (
            <QuestionItem
              key={item.questionId}
              question={item.questionName}
              questionId={item.questionId}
              isSelected={item.isSelected}
              isParent={isParentQuestion}
            />
          );
        })}
    </div>
  );
}
